import { useNavigate, useParams } from "react-router-dom"

export const withHooks=(Component) => {
    return props => <Component {...props} params={useParams()} navigate={useNavigate()} />
}